import React from 'react';
import { ENTRIES } from './experienceData';

const ExperiencesSection = ({ activeId, onSelect }) => {
  const active = ENTRIES.find((e) => e.id === activeId) || ENTRIES[0];

  return (
    <section className="exp">
      <div className="exp-wrapper">
        <div className="tab-list" role="tablist" aria-label="Experience">
          {ENTRIES.map((entry) => (
            <button
              key={entry.id}
              role="tab"
              aria-selected={activeId === entry.id}
              className={`tab-btn ${activeId === entry.id ? 'active' : ''}`}
              onClick={() => onSelect(entry.id)}
            >
              {entry.logo && (
                <span className="logo-chip logo-chip-sm">
                  <img src={entry.logo} alt="" />
                </span>
              )}
              {entry.tab}
            </button>
          ))}
        </div>

        <div className="entry-detail" role="tabpanel">
          <div className="entry-header">
            {active.logo && (
              <span className="logo-chip logo-chip-lg">
                <img src={active.logo} alt={`${active.org} logo`} />
              </span>
            )}
            <p className="entry-role">
              {active.role} <span className="entry-org">@ {active.org}</span>
            </p>
          </div>
          <p className="entry-meta">
            {active.location} &middot; {active.dates}
          </p>
          <ul className="entry-bullets">
            {active.bullets.map((b, i) => (
              <li key={i}>{b}</li>
            ))}
          </ul>
          <p className="entry-skills">
            <span className="skills-label">skills:</span> {active.skills.join(', ')}
          </p>
          {active.link && (
            <a className="entry-link" href={active.link.href} target="_blank" rel="noopener noreferrer">
              [ {active.link.label} ]
            </a>
          )}
        </div>
      </div>
    </section>
  );
};

export default ExperiencesSection;
